import { IS_MOBILE_BY_DEFAULT } from '~/../node_modules/elixir-theme/src/constants/MobileConstants';
import {
  MenuItemsInterface as MenuItems,
  MenuLinkInterface,
} from 'elixir-theme';
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'NavBar',
})
export default class NavBar extends Vue {
  @Prop({ required: true })
  public readonly logoWidth!: number | string;

  @Prop({ required: true })
  public readonly items!: MenuItems;

  @Prop({ required: true })
  public readonly mobileLogoWidth!: number;

  @Prop({ required: true })
  public readonly logoUrl!: string;

  @Prop({ required: false, default: '' })
  public readonly logoSrcSet!: string;

  @Prop({ required: false, default: '180px' })
  public readonly logoSrcSizes!: string;

  @Prop({ required: false, default: undefined })
  public readonly logoLink!: string | undefined;

  @Prop({ required: false, default: undefined })
  public readonly homeIconLink!: string | undefined;

  @Prop({ required: false, default: false })
  public readonly showHomeIcon!: boolean;

  @Ref('bottomBar')
  public readonly bottomBar!: Vue | undefined;

  protected isMobile: boolean = IS_MOBILE_BY_DEFAULT;

  protected showSearch: boolean = false;

  protected drawer: boolean = false;

  protected showMobileSearch: boolean = false;

  public beforeMount() {
    this.$on('hideSearch', () => {
      this.showSearch = false;
      this.showMobileSearch = false;

      if (this.bottomBar) {
        this.bottomBar.$emit('hideSearch');
      }
    });
  }

  public mounted() {
    this.setMobile();
  }

  public render() {
    return (
      <div class='nav-bar'>
        <v-row
          class={this.isMobile ? 'px-4 pt-4 pb-0' : 'pb-4'}
          no-gutters
          align='center'
        >
          <v-col class='pt-4 pr-4' cols='8' lg='2'>
            {this.logoLink ? (
              <router-link to={this.logoLink}>
                <v-img
                  class='nav-bar__logo'
                  src={this.logoUrl}
                  srcset={this.logoSrcSet}
                  sizes={this.logoSrcSizes}
                  width={this.currentLogoWidth}
                />
              </router-link>
            ) : (
              <div onClick={this.logoClick}>
                <v-img
                  class='nav-bar__logo'
                  src={this.logoUrl}
                  srcset={this.logoSrcSet}
                  sizes={this.logoSrcSizes}
                  width={this.currentLogoWidth}
                />
              </div>
            )}
          </v-col>
          <v-col class='hidden-md-and-down' lg='10'>
            <v-row no-gutters justify-lg='end' class='pl-lg-12'>
              <v-col lg='12'>
                {this.items.topBarLinks ? (
                  <nav-bar-top-row
                    newsletterLink={this.items.newsletterLink}
                    icons={this.items.topBarSocialIcons}
                    links={this.items.topBarLinks}
                    phoneNumber={this.items.phoneNumber}
                    onButtonBarLinkClick={this.buttonBarLinkClick}
                  />
                ) : null}
              </v-col>
              <v-col lg='12'>
                <divider-line vuetifyClass='primary' />
              </v-col>
              <v-col lg='12'>
                {this.items.bottomBarLinks ? (
                  <nav-bar-bottom-row
                    ref='bottomBar'
                    links={this.items.bottomBarLinks}
                    searchText={this.items.searchText}
                    homeIconLink={this.homeIconLink}
                    onHomeIconClick={this.homeIconClick}
                    onSearchButtonClick={this.searchButtonClick}
                    onButtonBarLinkClick={this.buttonBarLinkClick}
                  />
                ) : null}
              </v-col>
            </v-row>
          </v-col>
          <v-col class='hidden-lg-and-up pr-2' cols='3'>
            <v-row no-gutters justify='end' align='center' class='text-end'>
              <v-col
                cols='12'
                sm='6'
                md='4'
                class='elix-subheading mt-2 mr-1 primary--text'
                onClick={(event: Event) => {
                  event.stopPropagation();
                  this.drawer = !this.drawer;
                }}
              >
                MENU
              </v-col>
            </v-row>
            <v-row no-gutters class='mt-2 mr-1 elix-subheading text-end'>
              <v-col cols='6' sm='9' md='10'>
                {this.homeIconLink && this.showHomeIcon ? (
                  <router-link
                    class='app__no-decoration-link'
                    to={this.homeIconLink}
                  >
                    <v-icon
                      large
                      right
                      class='primary--text ml-0 mr-1 mr-sm-0 ml-md-0 mr-md-1'
                    >
                      home
                    </v-icon>
                  </router-link>
                ) : null}
                {!this.homeIconLink && this.showHomeIcon ? (
                  <div
                    class='app__no-decoration-link'
                    onClick={this.homeIconClick}
                  >
                    <v-icon
                      large
                      right
                      class='primary--text ml-0 mr-1 mr-sm-0 ml-md-0 mr-md-1'
                    >
                      home
                    </v-icon>
                  </div>
                ) : null}
              </v-col>
              <v-col cols='6' sm='3' md='2'>
                <v-icon
                  large
                  right
                  class='primary--text'
                  onClick={(event: Event) => {
                    event.stopPropagation();
                    this.drawer = !this.drawer;
                  }}
                >
                  menu
                </v-icon>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-dialog v-model={this.showMobileSearch} persistent fullscreen>
          <background-wrapper
            class='nav-bar__dialog-wrapper'
            stripeColor='rgba(37,95,193,0.96)'
          >
            <v-row no-gutters justify='space-around'>
              <v-row no-gutters justify='end'>
                <v-icon
                  x-large
                  color='contrast'
                  class='pt-4 pr-4'
                  onClick={this.toggleMobileSearch}
                >
                  close
                </v-icon>
                {this.showMobileSearch ? (
                  <search-popup
                    class='px-4'
                    title={this.items.searchTitle}
                    optionLinks={this.items.searchOptionButtons}
                    searchItems={this.items.searchDestinationList}
                    searchButtonText={this.items.searchButtonText}
                    searchPlaceholder={this.items.searchPlaceholder}
                    mobile
                    onButtonArrowClick={this.buttonArrowClick}
                    onSubmitInput={this.submitSearch}
                  />
                ) : null}
              </v-row>
            </v-row>
          </background-wrapper>
        </v-dialog>

        <div class='nav-bar__search-popup mt-n2'>
          <background-wrapper stripeColor='rgba(37,95,193,0.96)'>
            <v-container class='py-0'>
              {this.showSearch ? (
                <search-popup
                  class='px-3'
                  title={this.items.searchTitle}
                  optionLinks={this.items.searchOptionButtons}
                  searchItems={this.items.searchDestinationList}
                  searchButtonText={this.items.searchButtonText}
                  searchPlaceholder={this.items.searchPlaceholder}
                  onButtonArrowClick={this.buttonArrowClick}
                  onSubmitInput={this.submitSearch}
                />
              ) : null}
            </v-container>
          </background-wrapper>
        </div>

        <v-navigation-drawer v-model={this.drawer} temporary app>
          <v-list class='mx-3 mt-3 mb-2'>
            <v-img
              src={this.logoUrl}
              srcset={this.logoSrcSet}
              sizes={this.logoSrcSizes}
              width={this.mobileLogoWidth}
            />
          </v-list>
          <v-list class='pt-3 mx-3'>
            {this.items.topBarLinks ? (
              <mobile-menu-links
                links={this.items.topBarLinks}
                onButtonClick={this.mobileMenuLinksClick}
              />
            ) : null}
            {this.items.bottomBarLinks ? (
              <mobile-menu-links
                links={this.items.bottomBarLinks}
                onButtonClick={this.mobileMenuLinksClick}
              />
            ) : null}
            {this.newsletterMobileItem ? (
              <mobile-menu-links
                links={this.newsletterMobileItem}
                onButtonClick={this.mobileMenuLinksClick}
              />
            ) : null}
            <v-list-item>
              <v-list-item-title onClick={this.toggleMobileSearch}>
                <a class='app__no-decoration-link'>
                  {this.items.searchButtonText}
                </a>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
      </div>
    );
  }

  protected get newsletterMobileItem(): MenuLinkInterface[] {
    return [
      {
        href: true,
        routeName: this.items.newsletterLink.href,
        name: this.items.newsletterLink.label,
        target: '_blank',
      },
    ];
  }

  protected get currentLogoWidth(): number | string {
    const numericLogoWidth = Number(this.logoWidth);

    if (this.isMobile && !Number.isNaN(numericLogoWidth)) {
      return numericLogoWidth * 0.72;
    }

    return this.logoWidth;
  }

  protected toggleMobileSearch() {
    this.drawer = false;
    this.showSearch = false;
    this.showMobileSearch = !this.showMobileSearch;
  }

  protected searchButtonClick() {
    this.showSearch = !this.showSearch;
  }

  protected logoClick() {
    this.$emit('logoClick');
  }

  protected homeIconClick() {
    this.$emit('homeIconClick');
  }

  protected buttonArrowClick() {
    this.$emit('searchPopup');
  }

  protected submitSearch(value: string | null) {
    this.$emit('submitSearch', value);

    return value;
  }

  protected mobileMenuLinksClick(name?: string) {
    this.$emit('mobileMenuLinksClick', name);
  }

  protected buttonBarLinkClick(name?: string) {
    this.$emit('buttonBarLinkClick', name);
  }

  @Watch('$vuetify.breakpoint.name')
  protected setMobile() {
    this.isMobile =
      this.$vuetify.breakpoint.name === 'xs' ||
      this.$vuetify.breakpoint.name === 'sm' ||
      this.$vuetify.breakpoint.name === 'md';
  }
}
